import React, { memo, useState } from 'react';
import SVG from 'react-inlinesvg';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames/bind';
import Avatar from '@material-ui/core/Avatar';
import Tooltip from '@material-ui/core/Tooltip';
import ConfirmationDialog from '../../../shared/components/ConfirmationDialog/ConfirmationDialog';
import { buildAvatarName } from '../../../shared/helpers/buildAvatarName';
import { baseURL } from '../../../shared/helpers/axiosConfiguration';
import styles from './userItem.module.scss';

const conditionalStyles = classNames.bind(styles);

export default memo(withRouter(function UserItem(props) {
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

    const defaultPictureURL = '/user/upload_pic/User-alt-128.png';

    function openDialog() {
        setOpenDeleteDialog(true);
    }

    function closeDialog() {
        setOpenDeleteDialog(false);
    }

    function confirmUserRemoval() {
        props.deleteUserRequest(props.user.UserId);

        setOpenDeleteDialog(false);
    }

    return (
        <div
            className={conditionalStyles({
                container: true,
                deleting: props.user.removing
            })}
        >
            <div className={styles.avatarContainer}>
                <Avatar
                    className={styles.avatar}
                    src={props.user.PictureURL !== defaultPictureURL ? `${baseURL}${props.user.PictureURL}` : null}
                >
                    {buildAvatarName(`${props.user.Names} ${props.user.LastNames}`)}
                </Avatar>
            </div>
            <div className={styles.dataContainer}>
                <div className={styles.data}>
                    <div className={styles.textContainer}>
                        <span>{props.user.Names} {props.user.LastNames}</span>
                    </div>
                    <div className={styles.textContainer}>
                        <span>{props.user.Emails}</span>
                    </div>
                </div>
                <div className={styles.data}>
                    <div className={styles.textContainer}>
                        <span>{props.user.MobileNumber}</span>
                    </div>
                </div>
                <div className={styles.data}>
                    <div className={styles.textContainer}>
                        <span>{props.user.Extension}</span>
                    </div>
                </div>
                <div className={styles.data}>
                    {
                        props.user.UserType === 'PHONE' &&
                        <SVG cacheGetRequests className={styles.normalStatus} src='./icons/phone.svg' />
                    }
                    {
                        props.user.UserType === 'VIDEOPHONE' &&
                        <SVG cacheGetRequests className={styles.normalStatus} src='./icons/video_camera.svg' />
                    }
                </div>
                <div className={styles.data}>
                    <Tooltip
                        disableFocusListener
                        disableTouchListener
                        title={props.user.SIPExtension.IPAddress || 'Not connected'}
                    >
                        <div
                            className={conditionalStyles({ ipContainer: props.user.SIPExtension.IPAddress })}
                            onClick={() => props.copyIP(props.user.SIPExtension.IPAddress, 'users:sip_ip_copied')}
                        >
                            <SVG
                                cacheGetRequests
                                className={conditionalStyles({
                                    okStatus: props.user.SIPExtension.IPAddress,
                                    errorStatus: !props.user.SIPExtension.IPAddress
                                })}
                                src="./icons/deskphone.svg"
                            />
                        </div>
                    </Tooltip>
                    <Tooltip
                        disableFocusListener
                        disableTouchListener
                        title={props.user.MOBILEExtension.IPAddress || 'Not connected'}
                    >
                        <div
                            className={conditionalStyles({ ipContainer: props.user.MOBILEExtension.IPAddress })}
                            onClick={() => props.copyIP(props.user.MOBILEExtension.IPAddress, 'users:mobile_ip_copied')}
                        >
                            <SVG
                                cacheGetRequests
                                className={conditionalStyles({
                                    okStatus: props.user.MOBILEExtension.IPAddress,
                                    errorStatus: !props.user.MOBILEExtension.IPAddress
                                })}
                                src="./icons/mobile_phone.svg"
                            />
                        </div>
                    </Tooltip>
                    <Tooltip
                        disableFocusListener
                        disableTouchListener
                        title={props.user.WEBExtension.IPAddress || 'Not connected'}
                    >
                        <div
                            className={conditionalStyles({ ipContainer: props.user.WEBExtension.IPAddress })}
                            onClick={() => props.copyIP(props.user.WEBExtension.IPAddress, 'users:web_ip_copied')}
                        >
                            <SVG
                                cacheGetRequests
                                className={conditionalStyles({
                                    okStatus: props.user.WEBExtension.IPAddress,
                                    errorStatus: !props.user.WEBExtension.IPAddress
                                })}
                                src="./icons/laptop.svg"
                            />
                        </div>
                    </Tooltip>
                </div>
                <div className={styles.data}>
                    {
                        props.user.UseVoicemail === '1' &&
                        <SVG cacheGetRequests className={styles.okStatus} src="./icons/check.svg" />
                    }
                </div>
                <div className={styles.data}>
                    {
                        props.user.ForwardConfig.length > 0 &&
                        <SVG cacheGetRequests className={styles.okStatus} src="./icons/check.svg" />
                    }
                </div>
                <div className={styles.data}>
                    {
                        props.user.Monitor !== '0' &&
                        <SVG cacheGetRequests className={styles.okStatus} src="./icons/check.svg" />
                    }
                </div>
                <div className={styles.actions}>
                    {   props.permissions!==null && parseInt(props.permissions[0])>=10 ?
                        <div className={styles.edit} onClick={() => props.history.push(`/users/${props.user.UserId}`)}>
                            <SVG cacheGetRequests className={styles.hidden} src="./icons/edit.svg" />
                        </div> :
                        null
                    }
                    {   props.permissions!==null && parseInt(props.permissions[0])==11 ?
                        <div onClick={openDialog}>
                            <SVG cacheGetRequests className={styles.hidden} src="./icons/trash.svg" />
                        </div> :
                        null
                    }
                    {
                        openDeleteDialog &&
                        <ConfirmationDialog
                            cancelText="common:cancel"
                            closeDialog={closeDialog}
                            confirm={confirmUserRemoval}
                            confirmationItem={`${props.user.Names} ${props.user.LastNames}`}
                            confirmText="common:delete"
                            detail="users:delete_detail"
                            dictionary={['common', 'users']}
                            open={openDeleteDialog}
                            title="users:delete_confirmation"
                        />
                    }
                </div>
            </div>
        </div>
    );
}, (prevProps, nextProps) => prevProps.user === nextProps.user));
